import { config } from "./config";
import { getOrigin, getQueryString, redirectTo, xhr } from "./window-utils";

function createQueryParams(params) {
    return Object.entries(params)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&");
}


export const cognito = {



    signupWithPassword: (email, password) => {

        return new Promise((ok, err) => {
            const userPool = new AmazonCognitoIdentity.CognitoUserPool({ // eslint-disable-line
                UserPoolId: config.UserPoolId,
                ClientId: config.CognitoClientId
            });

            var attributeList = [];

            userPool.signUp(email, password, attributeList, null, function (
                e,
                result
            ) {
                if (e) {
                    err(e.message || JSON.stringify(e));
                    return;
                }
                
                const cognitoUser = new AmazonCognitoIdentity.CognitoUser({ // eslint-disable-line
                    Username: email,
                    Pool: userPool
                });

                cognitoUser.authenticateUser(
                    new AmazonCognitoIdentity.AuthenticationDetails({ // eslint-disable-line
                        Username: email,
                        Password: password
                    }),
                    {
                        onSuccess: (r) => {
                            const token = { id_token: r.getIdToken().getJwtToken(), refresh_token: r.getRefreshToken().getToken() }
                            console.log(token);
                            ok(token);
                        },
                        onFailure: err,
                    }
                );


                console.log('user name is ' + cognitoUser.getUsername());
            });
        })
    },

    signupWithGoogle: () => {
        const queryParams = createQueryParams({
            response_type: "code",
            client_id: config.CognitoClientId,
            redirect_uri: `${getOrigin()}/joined/`,
            identity_provider: "Google",
            scope: "email openid profile"
        });
        redirectTo(`${config.CognitoUrl}/oauth2/authorize?${queryParams}`);
    },


    getToken: async () => {
        const body = createQueryParams({
            grant_type: "authorization_code",
            redirect_uri: `${getOrigin()}/joined/`,
            code: getQueryString().split("?code=")[1],
            client_id: config.CognitoClientId,
        });
        const response = await xhr(`${config.CognitoUrl}/oauth2/token`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
            body
        });

        if(!response) {
            return null;
        }


        return await response.json();
    }


}

